import Chart from 'chart.js';

const chartContainer = document.querySelector('.fund-graph');

if (chartContainer) {
    const chartEl = document.getElementById('heimdal-chart');
    const customSelect = document.querySelector('.custom-select');
    const $chartWrapper = $('.chart .chart-wrapper');
    const $loadingSpinner = $('.chart .loading-spinner');
    const $noDataMessage = $('.chart .no-data');
    const $fromDate = $('#graph-from-date');
    const $toDate = $('#graph-to-date');
    const $totalReturn = $('.return');
    let chart = null;
    let isFirstLoad = true;

    if (customSelect) {
        // Filtering functionality
        customSelect.addEventListener('change', function (e) {
            const filterValue = e.detail.value;
            const fundName = e.detail.fundName;
            const andelsklasse = e.detail.andelsklasse;

            var searchParams = new URLSearchParams(window.location.search);
            searchParams.set("andelsklasse", andelsklasse);
            window.location.search = searchParams.toString();
        });
    }

    if (chartEl) {
        const instrumentCode = chartEl.getAttribute('data-instrument-code');
        const dateFormatter = new Intl.DateTimeFormat('nb-NO', {dateStyle: 'short'});
        const numberFormatter = new Intl.NumberFormat('nb-NO', {maximumFractionDigits: 2});

        const config = {
            type: "line",
            data: {
                labels: [],
                datasets: []
            },
            options: {
                scales: {
                    xAxes: [
                        {
                            type: 'time',
                            ticks: {
                                maxTicksLimit: 7,
                                maxRotation: 0,
                            }
                        }
                    ]
                },
                legend: {
                    display: false
                },
                elements: {
                    point: {
                        radius: 0,
                        borderWidth: 0,
                    }
                },
                tooltips: {
                    callbacks: {
                        title: function(tooltipItem, data) {
                            return dateFormatter.format(new Date(tooltipItem[0].xLabel));
                        },
                        label: function(tooltipItem, data) {
                            return numberFormatter.format(tooltipItem.yLabel);
                        }
                    }
                },
            }
        };
        Chart.defaults.global.defaultFontFamily = 'Suisse';
        chart = new Chart('heimdal-chart', config);

        if (instrumentCode) {
            loadGraphData(instrumentCode);

            $('#graph-show').click(function () {
                loadGraphData(instrumentCode, $fromDate.val(), $toDate.val());
            })
        }
    }

    function loadGraphData(instrumentCode, fromDate = null, toDate = null) {
        let data = new FormData();
        data.append('action', 'get_chart_data');
        data.append('instrumentCode', instrumentCode);

        if (fromDate) {
            data.append('fromDate', fromDate);
        }
        if (toDate) {
            data.append('toDate', toDate);
        }

        $.ajax({
            url: heimdal_scripts.ajax_url,
            type: 'POST',
            data: data,
            cache: false,
            processData: false,
            contentType: false,
            dataType: "json",
            error: function (data) {
                console.error(data);
            },
            complete: function (data) {
                const json = data.responseJSON;
                if (json && json['datasets']) {
                    const datasets = json['datasets'] || [];
                    for (const key in datasets) {
                        chart.data.datasets[key] = {
                            data: datasets[key],
                            borderColor: '#CDAD80',
                            backgroundColor: '#CDAD80',
                            fill: false,
                            showLine: true,
                            spanGaps: true,
                        };
                    }

                    chart.update();

                    if (isFirstLoad && json['datasets'].length > 0) {
                        const firstDataSet = json['datasets'][0];
                        const lastDataSet = json['datasets'][json['datasets'].length - 1];
                        if (firstDataSet && firstDataSet.length > 0) {
                            $fromDate.val(firstDataSet[0]['x']);
                        }
                        if (lastDataSet && lastDataSet.length > 0) {
                            $toDate.val(lastDataSet[lastDataSet.length - 1]['x']);
                        }
                    }

                    const numberFormatter = new Intl.NumberFormat("nb-NO", { maximumFractionDigits: 2, minimumFractionDigits: 2 });
                    if (json['return']) {
                        $totalReturn.html(numberFormatter.format(parseFloat(json['return']) * 100) + '%');
                    }

                    $loadingSpinner.hide();
                    if (json['datasets'].length > 0 && json['datasets'][0].length > 0) {
                        $chartWrapper.show();
                        $noDataMessage.hide();
                    } else {
                        $chartWrapper.hide();
                        $noDataMessage.show();
                    }
                    isFirstLoad = false;
                }
            }
        });
    }
}
